import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes.js'
import store from '~/store'
import {sync} from 'vuex-router-sync'

Vue.use(VueRouter);

Vue.prototype.route = window.route = (route, params = {}) => {

    let obj = [];

    if (!(route in window.routes)) {
        return console.warn('Route ' + route + ' not recognised', window.routes)
    }
    let url = window.routes[route];

    // Remove optional parameters from the url, if they have not been added to the request
    let match = new RegExp('({([a-zA-Z]+)\\?}(/?))').exec(url);
    while (match != null) {
        if(!(match[2] in params)) {
            // If it doesn't exist, remove it from the url
            url = url.replace(match[1], '')
        } else if(match[2] in params) {
            // Replace optional with normal parameter (without questionmark)
            url = url.replace(match[1], '{' + match[2] + '}' + match[3])
        }

        match = new RegExp('({([a-zA-Z]+)\\?}/?)').exec(url);
    }

    for(let parameter in params) {
        if(!url.includes('{' + parameter + '}')) {
            obj.push({ parameter: parameter, value: params[parameter]});
        }

        url = url.replace('{' + parameter + '}', params[parameter])
    }

    let query = '';

    for(let index in obj) {
        if (obj[index].value instanceof Array) {

            // Allow array notation of variables
            for (let value in obj[index].value) {
                query += (parseInt(index) === 0 ? '?' : '&') + obj[index].parameter + '[]=' + obj[index].value[value];
            }

        } else {
            query += (parseInt(index) === 0 ? '?' : '&') + obj[index].parameter + '=' + obj[index].value;
        }
    }

    return '/' + url + query;
};

const router = make(
    routes({authGuard, guestGuard, adminGuard})
);

sync(store, router);

export default router

function make(routes) {
    const router = new VueRouter({
        routes,
        hashbang: false,
        mode: 'history',
        linkActiveClass: "active"
    });

    router.beforeEach(async (to, from, next) => {
        // If somebody opened a link, while not being logged in, and got redirected to login
        // Redirect to the page they tried to open.
        const navigationHistory = store.getters.history;
        if (from.name === 'login'
            && to.name !== 'password.reset'
            && to.name !== 'password.reset.token'
            && to.name !== 'login.verify'
            && navigationHistory
            && navigationHistory.length > 1
        ) {
            let redirect = navigationHistory[navigationHistory.length - 2];
            store.dispatch('clearHistory');

            // Disabled the fancy smancy failing redirect to previous page functionality.
            // router.push({ name: redirect.name });
        }

        store.dispatch('addHistory', from);
        store.commit("ROUTE_CHANGE", "start");
        if (!store.getters.authCheck && store.getters.authToken) {
            const guestAuthRoutes = ['login', 'login.verify', 'password.reset', 'password.reset.token'];

            if (guestAuthRoutes.includes(to.name)) {
                store.dispatch('resetUser');
            } else {
                try {
                    await store.dispatch('fetchUser')
                } catch (e) {
                    //
                }
            }
        }

        // scroll to top when changing pages
        if (document.scrollingElement) {
            document.scrollingElement.scrollTop = 0;
        } else if (document.documentElement) {
            document.documentElement.scrollTop = 0;
        }
        next()
    });

    //====change page title after route change

    router.afterEach((to, from) => {

        if (to.meta.title) {
            document.title = uLang('app.' + to.meta.title) + " - " + config.name;
        }

        store.commit("ROUTE_CHANGE", "end");

        if (window.innerWidth <= 992) {
            store.commit('LEFT_MENU', "close");
        } else {
            store.commit('LEFT_MENU', "init");
        }
    });

    return router;
}

function adminGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        let permitted = false

        if (to.meta.dataExport) {
            permitted = window.$hasRole('super_admin') || window.$hasType('id_employee')
        } else {
            if (Array.isArray(to.meta.permission)) {
                for (let i = 0; i < to.meta.permission.length; i++) {
                    if (window.$can(to.meta.permission[i])) {
                        permitted = true
                    }
                }
            }

            if (typeof to.meta.permission == 'string' && window.$can(to.meta.permission)) {
                permitted = true
            }

            if (to.meta.permission == undefined) {
                permitted = true
            }
        }

        if (permitted) {
            next()
        } else {
            if (window.vue) {
                window.vue.$snotify.info(uLang('app.lack_of_permission_routes'), uLang('app.unauthorized'));
            }
            next({name: 'dashboard'})
        }
    })
}

function authGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (!store.getters.authCheck) {
            next({name: 'login'})
        } else {
            next()
        }
    })
}

/**
 * Redirect home if authenticated.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function guestGuard(routes) {
    return beforeEnter(routes, (to, from, next) => {
        if (store.getters.authCheck) {
            next({name: 'dashboard'})
        } else {
            next()
        }
    })
}

function beforeEnter(routes, beforeEnter) {
    return routes.map(route => {
        return {...route, beforeEnter}
    })
}
